<template>
  <div :class="$pgCTStyle.container">
    <div :class="$pgCTStyle.headerContainer">
      <!-- <div v-if="showAllGroupsCTA" :class="$style.titleEmptyContainer"></div> -->
      <div :class="$pgCTStyle.title">{{ computedTitle }}</div>
      <div :class="$pgCTStyle.headerRightCTAs">
        <PGHeaderActionButton
          v-if="showAllGroupsCTA"
          :text="$t('all-groups')"
          :clickFunction="openAllGroupsResultTextsVotes"
          backBg="#000000"
          frontBg="#676767"
          textColor="#ffc642"
          :button-width="isMobile ? '70px' : isTablet ? '72px' : '86px'"
        />
      </div>
    </div>
    <div :class="$pgCTStyle.bodyContainer">
      <div :class="$style.textContainer" v-for="text in texts" :key="text.id">
        <div :class="$style.textTopContainer" @click="toggleExpandText(text.id)">
          <div :class="$style.textTopLeftContainer">
            <div :class="$style.textLabel">{{ $t('text') }} {{ text.label }}</div>
            <div v-if="realTextId && parseInt(realTextId) == text.id" :class="$style.correctTextChip">{{ $t('correct-text') }}</div>
          </div>
          <div :class="$style.textTopRightContainer">
            <div :class="$style.textVotes">{{ text.votes ?? 0 }}, {{ $t('votes') }}</div>
            <div
              :class="$style.dropDownIconContainer"
              @click.stop="toggleExpandText(text.id)"
            >
              <img
                :src="dropDownIcon"
                alt="icon"
                :class="[$style.dropDownIcon, expandStates[text.id] ? $style.iconRotated : '']"
              />
            </div>
          </div>
        </div>
        <transition
          @before-enter="beforeEnter"
          @enter="enter"
          @after-enter="afterEnter"
          @before-leave="beforeLeave"
          @leave="leave"
          @after-leave="afterLeave"
        >
        <div v-if="expandStates[text.id]" :class="$style.textBottomContainer">
          <template v-if="votersForText(text.id).length">
            <div v-for="p in votersForText(text.id)" :key="p.id" :class="$style.voterRow">
              <img :src="p.avatar" :alt="p.username" :class="$style.voterAvatar" />
              <div :class="$style.voterName">{{ p.username }}</div>
            </div>
          </template>

          <template v-else>
            <div :class="$style.noVotersText">No votes for this text.</div>
          </template>
        </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import styles from "@/css/TextVotesBox.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
import DropDownIcon from "@/assets/icons/down-black.svg";
import { NOOP } from "@/utils/functions";
// import UtilButton from "../util/UtilButton.vue";
import useDeviceType from "@/utils/useDeviceType";
import PGHeaderActionButton from "../buttons/PGHeaderActionButton.vue";

const device = useDeviceType();

export default {
  components: { PGHeaderActionButton },
  name: "TextVotesBox",
  props: {
    canOpenAllGroups: { 
      type: Boolean, 
      required: false, 
      default: false
    },
    texts: {
      type: Array,
      required: true,
    },
    players: {
      type: Array,
      required: false,
      default: () => [],
    },
    realTextId: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    openAllGroupsResultTextsVotes: {
      type: Function,
      required: false,
      default: NOOP,
    },
    isHost: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dropDownIcon: DropDownIcon,
      expandStates: {}, // Store expand state keyed by text ID
    };
  },

  setup(props) {
    const { t: translate } = useI18n();

    const computedTitle = computed(() => {
      return props.title || translate("text-votes-received");
    });

    return {
      translate,
      computedTitle,
    };
  },

  computed: {
    $style() {
      return styles;
    },
    $pgCTStyle() {
      return playGameComponentsTemplateStyles;
    },
    width() {
      return device.width.value;
    },
    height() {
      return device.height.value;
    },
    isMobile() {
      return device.isMobile.value;
    },
    isTablet() {
      return device.isTablet.value;
    },
    isDesktop() {
      return device.isDesktop.value;
    },
    // textsWithState() {
    //   // Merge texts with their expand state
    //   return this.texts.map((text) => ({
    //     ...text,
    //     expandText: this.expandStates[text.id] ?? false,
    //   }));
    // },
    showAllGroupsCTA() {
      return this.openAllGroupsResultTextsVotes !== NOOP && this.canOpenAllGroups;
    },
  },
  methods: {
    toggleExpandText(textId) {
      this.expandStates[textId] = !this.expandStates[textId];
    },
    beforeEnter(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    },
    enter(el, done) {
      const height = el.scrollHeight;
      el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      el.style.height = height + "px";
      el.style.opacity = "1";
      setTimeout(() => {
        el.style.height = "auto";
        done();
      }, 300);
    },
    votersForText(textId) {
      return (this.players || []).filter((p) => Number(p.votedTextId) === Number(textId));
    },
    afterEnter(el) {
      el.style.height = "auto";
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    leave(el, done) {
      el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      el.style.height = "0";
      el.style.opacity = "0";
      setTimeout(() => {
        done();
      }, 300);
    },
    afterLeave(el) {
      el.style.height = "auto";
    },
  },
  created() {},
  mounted() {
    this.texts.forEach((text) => {
      this.expandStates[text.id] = false;
    });
  },
  beforeUnmount() {},
  watch: {},
};
</script>

<style scoped></style>
